import type React from 'react';

export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]) as unknown as unknown[];
export const EMPTY_SET = Object.freeze(new Set());

export const EMPTY_FUNCTION = () => EMPTY_OBJECT;

export function NULL_COMPONENT(): React.ReactNode {
  return null;
}
